// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_cW9","right":"styles_right__GGo0H"};